import { render, staticRenderFns } from "./importCommodityInfoModal.vue?vue&type=template&id=6ff81319&scoped=true"
import script from "./importCommodityInfoModal.vue?vue&type=script&lang=js"
export * from "./importCommodityInfoModal.vue?vue&type=script&lang=js"
import style0 from "./importCommodityInfoModal.vue?vue&type=style&index=0&id=6ff81319&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff81319",
  null
  
)

export default component.exports